import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const myDayRoute = createRoute({
  path: 'my-day',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/my-day/page'), 'MyDayPage'),
  errorComponent: RouteError,
})
